import CategoryIcon from "@mui/icons-material/Category";

// Central icon for content blocks. Replace here to update everywhere.
export default CategoryIcon;
